import { observable, action } from 'mobx';
import PrivateDriveApi from 'Api/private_drive/private_drive.api';
import { fileController } from 'Components/viewer/Controllers/index';
import {isMobile} from 'Utils/device';

const defaultModalContentHeight = '173px';
const openFileModalContentHeight = '494px';
const saveFileModalContentHeight = '397px';
const defaultModalContentHeightForMobile = '366px';
// const openFileModalContentHeightForMobile = 'calc(100vh - 172px)';
const openFileModalContentHeightForMobile = `${window.innerHeight - 172}px`;
// const saveFileModalContentHeightForMobile = 'calc(100vh - 271px)';
const saveFileModalContentHeightForMobile = `${window.innerHeight - 271}px`;

function isSameStorageFn(selectedStorage, compareStorage) {
  // alias: selectedStorage.alias,
  //   bucket: selectedStorage.bucket,
  //   endpoint: selectedStorage.endpoint,
  //   type: selectedStorage.type,
  if (
    selectedStorage.alias === compareStorage.alias &&
    selectedStorage.endpoint === compareStorage.endpoint &&
    selectedStorage.bucket === compareStorage.bucket &&
    selectedStorage.type === compareStorage.type
  ) {
    return true;
  } else {
    return false;
  }
}
export default class PrivateDriveStore {
  constructor() {
    this.privateDriveApi = new PrivateDriveApi();
  }
  @observable loadingDocBuffer = false;
  @observable numberOfAjaxCAllPending = 0;
  @observable isLoading = false;
  @observable showSignInPanel = true;
  @observable fileOpenedFrom = '';
  @observable isOpenedFromPrivateDrive = false;
  @observable operateType = '';
  @observable username = {
    SMB: '',
    S3: '',
    NFS: '',
  };
  @observable password = {
    SMB: '',
    S3: '',
    NFS: '',
  };
  @observable RSAPublicKey = '';
  @observable apiAuthenticationParams = [];
  @observable driveName = '';
  // @observable isSignIn = {
  //   SMB: false,
  //   S3: false,
  //   NFS: false,
  // };
  @observable isSignIn = [];
  @observable driveModalContentHeight = defaultModalContentHeight;
  @observable setApiAuthenticationParams(item) {
    this.apiAuthenticationParams.push(item);
  }
  @observable getSelectedAuthenticationParams() {
    let result;

    this.apiAuthenticationParams.some((item) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(this.selectedStorage, storage);

      if (isSameStorage) {
        result = item;

        return true;
      }
      return false;
    });

    return result;
  }
  @observable storageConfig = {
    storage: [],
  };
  // @observable selectedStorage = {
  //   SMB: {},
  //   S3: {},
  //   NFS: {},
  // };
  @observable selectedStorage = {};
  @observable showDrivesPanel = false;
  // @observable folderPath = {
  //   SMB: [
  //     {
  //       text: 'SMB',
  //       name: '',
  //     },
  //   ],
  //   S3: [
  //     {
  //       text: 'S3',
  //       name: '',
  //     },
  //   ],
  //   NFS: [
  //     {
  //       text: 'NFS',
  //       name: '',
  //     },
  //   ],
  // };
  @observable folderPath = [];
  // @observable filesData = {
  //   SMB: [],
  //   S3: [],
  //   NFS: [],
  // };
  @observable filesData = [];
  @observable openedFileInfo = {
    driveName: '',
    filePath: '',
    item: null,
  };
  @action numberOfAjaxCAllPendingIncrease() {
    this.numberOfAjaxCAllPending++;
  }
  @action numberOfAjaxCAllPendingDecrease() {
    this.numberOfAjaxCAllPending !== 0 && this.numberOfAjaxCAllPending--;
  }
  @action resetNumberOfAjaxCAllPending() {
    this.numberOfAjaxCAllPending = 0;
  }
  @action setShowSignInPanel(value) {
    this.showSignInPanel = value;

    if (value) {
      !isMobile && (this.driveModalContentHeight = defaultModalContentHeight);
      isMobile && (this.driveModalContentHeight = defaultModalContentHeightForMobile);
    } else {
      !isMobile && this.operateType === 'open' && (this.driveModalContentHeight = openFileModalContentHeight);
      !isMobile && this.operateType === 'save' && (this.driveModalContentHeight = saveFileModalContentHeight);
      isMobile && this.operateType === 'open' && (this.driveModalContentHeight = openFileModalContentHeightForMobile);
      isMobile && this.operateType === 'save' && (this.driveModalContentHeight = saveFileModalContentHeightForMobile);
    }
  }
  @action setIsLoading(val) {
    this.isLoading = val;
  }
  @action setShowDrivesPanel(val) {
    this.showDrivesPanel = val;

    if (this.showSignInPanel) {
      !isMobile && (this.driveModalContentHeight = defaultModalContentHeight);
      isMobile && (this.driveModalContentHeight = defaultModalContentHeightForMobile);
    } else {
      !isMobile && this.operateType === 'open' && (this.driveModalContentHeight = openFileModalContentHeight);
      !isMobile && this.operateType === 'save' && (this.driveModalContentHeight = saveFileModalContentHeight);
      isMobile && this.operateType === 'open' && (this.driveModalContentHeight = openFileModalContentHeightForMobile);
      isMobile && this.operateType === 'save' && (this.driveModalContentHeight = saveFileModalContentHeightForMobile);
    }
  }
  @action setIsSignIn(value) {
    let existSelectedStorageIsSignIn = this.isSignIn.some((item) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(value.storage, storage);

      if (isSameStorage) {
        item.isSignIn = value.isSignIn;

        return true;
      }

      return false;
    });

    if (!existSelectedStorageIsSignIn) {
      this.isSignIn.push(value);
    }
    // this.isSignIn[this.driveName] = val;

    // if (val === true) {
    //   this.driveModalContentHeight[this.driveName] = openFileModalContentHeight;
    // } else {
    //   this.driveModalContentHeight[this.driveName] = defaultModalContentHeight;
    // }
  }
  @action setStorageConfig(config) {
    this.storageConfig = config;
  }
  @action setSelectedStorage(item) {
    this.selectedStorage = item;
  }
  @action setFilesData(value) {
    let existSelectedStorageFilesData = this.filesData.some((item) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(value.storage, storage);

      if (isSameStorage) {
        item.data = value.data;

        return true;
      }

      return false;
    });

    if (!existSelectedStorageFilesData) {
      this.filesData.push(value);
    }
  }
  @action setAuthenticationParams({ RSAPublicKey, username, password }) {
    this.RSAPublicKey = RSAPublicKey;
    this.username[this.driveName] = username;
    this.password[this.driveName] = password;
  }
  @action pushFolderPath(item) {
    this.folderPath.push(item);
  }
  @action cleanFolderPath() {
    this.folderPath.some((item, index) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(this.selectedStorage, storage);

      if (isSameStorage) {
        this.folderPath.splice(index, 1);

        return true;
      }

      return false;
    });
  }
  @action setFolderPath(folder) {
    let existSelectedStorageFolderPath = this.folderPath.some((item) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(this.selectedStorage, storage);

      if (isSameStorage) {
        if (typeof folder === 'number') {
          item.path = item.path.slice(0, folder + 1);
        } else {
          item.path = [...item.path, folder];
        }

        return true;
      }

      return false;
    });

    if (!existSelectedStorageFolderPath) {
      this.folderPath.push(folder);
    }
  }
  @action setDriveName(val) {
    this.driveName = val;
  }
  @action setOpenedFileInfo({ driveName, filePath, item }) {
    let openedFileInfo = { driveName, filePath, item };

    this.openedFileInfo = openedFileInfo;
  }
  @action getCurrentFolder() {
    let currentFolder = '';

    this.folderPath.some((item) => {
      let { storage } = item;
      let isSameStorage = isSameStorageFn(this.selectedStorage, storage);

      if (isSameStorage) {
        item.path.forEach((item) => {
          currentFolder += item.name;
        });
      }

      return false;
    });
    // this.folderPath[this.driveName].forEach((item) => {
    //   currentFolder += item.name;
    // });

    return currentFolder;
  }
  @action setOperateType(val) {
    this.operateType = val;
  }
  @action setIsOpenedFromPrivateDrive(val) {
    this.isOpenedFromPrivateDrive = val;
  }
  @action setFileOpenedFrom(val) {
    this.fileOpenedFrom = val;
  }
  @action setLoadingDocBuffer(val) {
    this.loadingDocBuffer = val;
  }

  // api request
  @action getStorageList(success) {
    this.privateDriveApi.getConfig((res) => {
      let smbArr = [];
      let s3Arr = [];
      let lDArr = [];

      if (res.data) {
        res.data.storage.forEach((item) => {
          if (item.type === 1) {
            smbArr.push(item);
          } else if (item.type === 2) {
            s3Arr.push(item);
          } else if (item.type === 3) {
            lDArr.push(item);
          }
        });

        res.data.storage = [...smbArr, ...s3Arr, ...lDArr];

        this.setStorageConfig(res.data);
      }

      success && success();
    });
  }
  @action getRSAPublicKey({ username, password }) {
    this.privateDriveApi.getRSAPublicKey((res) => {
      const RSAPublicKey = res.data.key;

      this.setApiAuthenticationParams({
        storage: JSON.parse(JSON.stringify(this.selectedStorage)),
        RSAPublicKey,
        username,
        password,
      });

      this.getRootItems();
    });
  }
  @action getRootItems() {
    this.privateDriveApi.getItems('/', (filesData) => {
      this.setFolderPath({
        storage: JSON.parse(JSON.stringify(this.selectedStorage)),
        path: [{ text: this.selectedStorage.alias, name: '/' }],
      });
      this.setShowSignInPanel(false);
      this.setIsSignIn({ storage: JSON.parse(JSON.stringify(this.selectedStorage)), isSignIn: true });
      this.setFilesData({ storage: JSON.parse(JSON.stringify(this.selectedStorage)), data: filesData });
    });
  }
  @action getItems(path, success) {
    this.privateDriveApi.getItems(path, (filesData) => {
      success && success(filesData);
    });
  }
  @action openFolderFromPath(path, index) {
    this.setFolderPath(index);

    path = this.getCurrentFolder() || '/';

    this.getItems(path, (filesData) => {
      const { selectedStorage } = this;

      this.setFilesData({ storage: JSON.parse(JSON.stringify(selectedStorage)), data: filesData });
    });
  }
  @action openFolder(folder) {
    let path = '';

    this.folderPath.forEach((item) => {
      let { storage, path: pathArr } = item;
      let isSameStorage = isSameStorageFn(this.selectedStorage, storage);

      if (isSameStorage) {
        pathArr.forEach((item) => {
          path += item.name;
        });
      }
    });

    this.getItems(`${path}${folder.name}`, (filesData) => {
      this.setFolderPath({ text: folder.text, name: `${folder.name}` });
      this.setFilesData({ storage: JSON.parse(JSON.stringify(this.selectedStorage)), data: filesData });
    });
  }
  @action async doSaveFile({ filename, success, fail }) {
    const path = this.getCurrentFolder();
    let blob;
    let fileName = filename;
    let fileBuffer;
    let fileType = 'application/pdf';

    this.setLoadingDocBuffer(true);

    try {
      fileBuffer = (await fileController.getCurrentDocBuffer())[0];

      this.setLoadingDocBuffer(false);
    } catch (error) {
      this.setLoadingDocBuffer(false);
    }

    blob = new Blob(fileBuffer, { type: fileType });
    blob.name = fileName;

    this.privateDriveApi.uploadFile(
      path,
      blob,
      () => {
        this.getItems(path, (filesData) => {
          this.setFilesData({ storage: JSON.parse(JSON.stringify(this.selectedStorage)), data: filesData });
        });

        success && success();
      },
      () => {
        fail && fail();
      },
    );
  }
  @action refreshFolder() {
    const currentFolderPath = this.getCurrentFolder();

    this.getItems(currentFolderPath, (filesData) => {
      this.setFilesData({ storage: JSON.parse(JSON.stringify(this.selectedStorage)), data: filesData });
    });
  }
  @action downloadFile({ item, success, fail }) {
    const filePath = this.getCurrentFolder();

    this.privateDriveApi.downloadFile(
      filePath,
      item,
      (blob) => {
        success && success({ blob, filePath });
      },
      (/* error */) => {
        fail && fail();
      },
    );
  }
  @action getUploadFileRequest() {
    return this.privateDriveApi.uploadFileRequest;
  }
  @action cancelUploadFile() {
    this.privateDriveApi.cancelUploadFile();
  }
  @action getDownloadFileRequest() {
    return this.privateDriveApi.downloadFileRequest;
  }
  @action cancelDownloadFile() {
    this.privateDriveApi.cancelDownloadFile();
  }
}
